import React from "react";
import styles from "./Transaction.module.scss";
import { 
    formatDate, 
    formatBadgeText,
    formatBadgeStyle,
    formatBorrowerName, 
    formatAmount 
} from "../utils/format";

export function Transaction({ item, onClick }) {

    const statusDate = item.statusChangedOn ? item.statusChangedOn : item.initiatedDate;
    const displayDate = formatDate(statusDate);
    const badgeText = formatBadgeText(item.status);
    const name = formatBorrowerName(item.consumer);
    const amount = formatAmount(item);
    const badgeStyle = formatBadgeStyle(item.status, styles);

    return (
        <div className={styles.transaction} onClick={() => onClick(item)}>
            <table>
                <tbody>
                    <tr>
                        <td className={styles.name}>{name}</td>
                        <td className={styles.amount}>{amount}</td>
                    </tr>
                    <tr>
                        <td className={styles.status}>
                            <span className={badgeStyle}>{badgeText}</span>
                        </td>
                        <td className={styles.date}>{displayDate}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
